import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function clickOnRemove() {
    const category = GA_EVENTS.fsRemoveInfoLightBox.category;
    const action = GA_EVENTS.fsRemoveInfoLightBox.actions.clickOnRemove;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function clickOnOk() {
    const category = GA_EVENTS.fsRemoveInfoLightBox.category;
    const action = GA_EVENTS.fsRemoveInfoLightBox.actions.clickOnOk;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action , label});
}

function clickOnLearnMore() {
    const category = GA_EVENTS.fsRemoveInfoLightBox.category;
    const action = GA_EVENTS.fsRemoveInfoLightBox.actions.clickOnLearnMore;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function close() {
    const category = GA_EVENTS.fsRemoveInfoLightBox.category;
    const action = GA_EVENTS.fsRemoveInfoLightBox.actions.close;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function open(from) {
    const category = GA_EVENTS.fsRemoveInfoLightBox.category;
    const action = GA_EVENTS.fsRemoveInfoLightBox.actions.open;
    const label = `Opened from within ${from}`;

    setBehaviourEvent({ category, action, label });
}

export {
    clickOnRemove,
    clickOnOk,
    clickOnLearnMore,
    close,
    open
};
